document.querySelectorAll('.arrow_up_home_page').forEach(element => {
    element.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: smooth scrolling
        });
    });
});
